import { useEffect, useContext } from "react"
import _ from "lodash"

import { useFormikContext } from "formik"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function SupervisionPlanChange(props) {
  const { block, field, index } = props
  const formik = useFormikContext()
  const form = useContext(FormContext)
  const { initialValues, values: currentValues } = formik
  const blockSaved = form.blocksSaved[block]

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (form.editMode) {
      const checkForChanges = () => {
        const controlValues = {
          supervision_session_topic: initialValues.supervision_session_topic,
          supervision_session_notes: initialValues.supervision_session_notes,
          supervision_session_outreach_plan:
            initialValues.supervision_session_outreach_plan,
          supervision_session_case_audit_notes:
            initialValues.supervision_session_case_audit_notes,
        }
        return _.reduce(
          controlValues,
          (acc, value, key) => {
            return _.isEqual(value, currentValues[key]) ? acc : true
          },
          false
        )
      }
      const recordNewChanges = checkForChanges()

      if (formik.values[field.field_name] !== recordNewChanges) {
        formik.setFieldValue(field.field_name, recordNewChanges)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [blockSaved])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
